import { SITE_ORIGIN } from "@/constants";

/** Site-root-relative paths and bundled asset URLs -> absolute URLs. */
export const absoluteUrl = (pathOrUrl: string): string =>
  /^https?:\/\//i.test(pathOrUrl)
    ? pathOrUrl
    : new URL(pathOrUrl, `${SITE_ORIGIN}/`).href;

const MONTHS_ES = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

/**
 * "2026-09-02" -> "2 de septiembre de 2026". Parsed from the string itself,
 * never through `new Date()`, so the server render and the browser render can
 * never disagree because of a timezone offset (which would break hydration).
 */
export function formatDateEs(iso: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!match) return iso;
  const [, year, month, day] = match;
  const name = MONTHS_ES[Number(month) - 1];
  if (!name) return iso;
  return `${Number(day)} de ${name} de ${year}`;
}
